import { render, staticRenderFns } from "./buying-group.vue?vue&type=template&id=18c2b945&scoped=true"
import script from "./buying-group.vue?vue&type=script&lang=js"
export * from "./buying-group.vue?vue&type=script&lang=js"
import style0 from "./buying-group.vue?vue&type=style&index=0&id=18c2b945&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c2b945",
  null
  
)

export default component.exports